var map = {
	"./grade12.png": "d1ba",
	"./grade13.png": "344e",
	"./grade14.png": "1c1a",
	"./grade15.png": "f96f",
	"./grade16.png": "017d",
	"./grade17.png": "fc88",
	"./grade19.png": "8677",
	"./grade20.png": "a9d0",
	"./grade21.png": "320a",
	"./grade22.png": "51c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7df2";